import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { LinkSimple, Trash, Lightning, ChartBar, ArrowRight } from "@phosphor-icons/react";

const steps = [
  { i: LinkSimple, t: "Connect your inboxes", d: "Securely link Gmail and Outlook via OAuth. We only request the minimum scopes needed." },
  { i: Trash, t: "Bulk delete what's noise", d: "Filter, select hundreds, and delete in a single click. Signal Red means business." },
  { i: Lightning, t: "Set forever-rules", d: "Promotions older than 30 days? Newsletters after 60? Set it once. The scheduler runs it." },
  { i: ChartBar, t: "Watch the time pile up", d: "Track top senders, deletion velocity, and minutes reclaimed. Brag responsibly." },
];

export default function OnboardingWizard({ open, onClose }) {
  const [step, setStep] = useState(0);
  const s = steps[step];
  const Icon = s.i;
  const last = step === steps.length - 1;
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="rounded-none max-w-lg" data-testid="onboarding-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Welcome to Easy Mail</DialogTitle>
          <DialogDescription>A 30-second tour of how to reclaim your inbox.</DialogDescription>
        </DialogHeader>
        <div className="py-6">
          <div className="flex items-center gap-3 mb-4">
            <Icon size={36} weight="duotone" className="text-primary" />
            <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Step {step + 1} of {steps.length}</div>
          </div>
          <h3 className="font-display text-2xl font-bold mb-2">{s.t}</h3>
          <p className="text-foreground/80">{s.d}</p>
        </div>
        <div className="flex items-center justify-between gap-3">
          <div className="flex gap-1">
            {steps.map((_, i) => (
              <div key={i} className={`h-1 w-8 ${i <= step ? "bg-foreground" : "bg-border"}`} />
            ))}
          </div>
          <div className="flex gap-2">
            {step > 0 && <Button variant="outline" className="rounded-none" onClick={() => setStep(step - 1)} data-testid="onboarding-back">Back</Button>}
            <Button
              className="rounded-none btn-brutalist gap-2"
              onClick={() => { if (last) onClose(); else setStep(step + 1); }}
              data-testid={last ? "onboarding-done" : "onboarding-next"}
            >
              {last ? "Let's go" : "Next"} <ArrowRight size={16} />
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
